import { scene } from '../main/scene-sidecar'
import { clickEater } from '../uiParts/clickEater-sidecar'
import { IDialog } from '../uiParts/dialogs'
import { dialogs } from '../uiParts/dialogs-sidecar'
import { IStevieText } from '../uiParts/stevieText'
import { stevieText } from '../uiParts/stevieText-sidecar'

interface IData {
  isOpen: boolean
  isCreated: boolean
  dialog: dialogs.IDialog
  texts: IStevieText[]
}
let _data: IData | null = null
export const getData = () => {
  if (!_data) {
    let ctx = scene.getContext()

    let x = 20
    let y = 100

    let texts: IStevieText[] = []

    let dialog: IDialog = dialogs.create(
      20,
      20,
      x,
      y,
      'Oxygen Gen options',
      () => {
        setOpen(false)
      },
    )

    _data = {
      isOpen: false,
      isCreated: false,
      dialog,

      texts,
    }
    setOpen(false)
  }
  return _data
}

export const toggle = () => {
  setOpen(!getData().isOpen)
}

export const setDesc = (name: string, desc: string) => {
  let data = getData()
}

export const setOpen = (isOpen: boolean) => {
  clickEater.update('uiOxygen', isOpen)

  let data = getData()
  data.isOpen = isOpen
  dialogs.setVisible(data.dialog, isOpen)
  stevieText.setBulkVisible(data.texts, isOpen)

  let xs = data.dialog.x + 25
  let xm = xs + 200
  let x = xs
  let y = data.dialog.y + 100
  let size = 75
  if (isOpen && !data.isCreated) {
    data.isCreated = true

    let adv = () => {
      x += size
      if (x > xm) {
        x = xs
        y += size
      }
    }
  }
}

export const update = () => {
  let data = getData()

  if (!data.isOpen) {
    return
  }

  let ctx = scene.getContext()
}
